export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const HOST_URL = process.env.REACT_APP_HOST_URL;
